<div class="route-component">
    <div class="search-component">
        <h4>{{ title }}</h4>

        <p>{{ message }}</p>
        <p>Your account: <strong>{{ userEmail }}</strong></p>

        <p>{{ actionMessage }}</p>

        <button class="btn btn-primary mt-3" (click)="signOut()">Sign Out</button>
    </div>
</div>
